import { getLocation } from './getLocation';
export function getHostName(url) {
    var location = getLocation(url);
    return (location && location.hostname) || '';
}
//# sourceMappingURL=getHostName.js.map